import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'oligonIson';
const args = {};

export class OligonIson extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
